import React, { useState, useEffect } from 'react';
import { Zap, ZapOff } from 'lucide-react';

const STORAGE_KEY = 'lite_mode';

/**
 * LiteModeToggle — a small badge button users can tap to switch the entire site
 * into a "lite" rendering mode (no blurs, no animations, solid colours).
 * Lifesaver for low-end Android phones whose GPU driver crashes on translucent
 * gradients + compositor layers.
 *
 * Stores preference in localStorage and applies `.lite-mode` to <body>.
 */
const LiteModeToggle = () => {
  const [enabled, setEnabled] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (_) { return false; }
  });

  useEffect(() => {
    if (enabled) {
      document.body.classList.add('lite-mode');
    } else {
      document.body.classList.remove('lite-mode');
    }
    try { localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0'); } catch (_) {}
  }, [enabled]);

  return (
    <button
      type="button"
      data-testid="lite-mode-toggle"
      onClick={() => setEnabled(v => !v)}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border ${enabled
        ? 'bg-amber-500 text-black border-amber-400'
        : 'bg-slate-800 text-amber-300 border-amber-500/30 hover:bg-slate-700'}`}
      title={enabled ? 'Lite Mode ON — सबसे smooth (low-end Android friendly)' : 'Phone hang/crash हो रहा है? यहाँ tap करें — सारे animations/gradients off'}
    >
      {enabled
        ? <><Zap className="w-3.5 h-3.5" /> Lite ON</>
        : <><ZapOff className="w-3.5 h-3.5" /> Lite Mode</>}
    </button>
  );
};

export default LiteModeToggle;
